export default __webpack_public_path__ + "media/react/pages/payment_flows/add_ons/assets/admissions/grad_school_logos-53cf4d268a9119f1d5852e610220401d.png";